const BankReceipt = ({ copyType, data }) => (
  <div className="bank-reciept">
    <p style={{
      color: '#dedede',
      fontSize: '24px',
      fontWeight: 'bolder',
      textAlign: 'center'
    }}>{copyType} COPY</p>
    <h2 style={{ fontSize: '15px' }}>Government Degree College Milak Rampur (U.P.)</h2>
    <h4>Union Bank of India 
Branch Shahabad
Rampur</h4>
    <p>------</p>
    <p>IFSC: UBIN0574996</p>
    <hr />
    <h4>Registration No. {data.id || 'N/A'}</h4>
    <p>Principal Govt Degree Coll. Milak Rampur</p>
    <p>A/C No. 749901010050252</p>
    <p>Session : {data.session}</p>
    <table className="denomination-table">
      <tbody>
        <tr><th colSpan="2">Denominations</th></tr>
        <tr><td>500 X</td><td></td></tr>
        <tr><td>200 X</td><td></td></tr>
        <tr><td>100 X</td><td></td></tr>
        <tr><td>50 X</td><td></td></tr>
        <tr><td>20 X</td><td></td></tr>
        <tr><td>10 X</td><td></td></tr>
        <tr><td>5 X</td><td></td></tr>
        <tr><td>2 X</td><td></td></tr>
        <tr><td>1 X</td><td></td></tr>
        <tr><td>Total</td><td></td></tr>
      </tbody>
    </table>
    <h4>Total Amount: {data.fees || 'N/A'}</h4>
    <ul style={{
      listStyle: 'none',
      padding: '0px',
      width: '100%',
      justifyContent: 'space-between',
      margin: '0 !important'
    }}>
      <li>
        <ul style={{
          display: 'flex',
          flexDirection: 'row',
          listStyle: 'none',
          padding: '0px',
          width: '100%',
          justifyContent: 'space-between',
         
          margin: '0 !important'
        }}>
          <li>________</li>
          <li>________</li>
        </ul>
      </li>
      <li>
        <ul style={{
          display: 'flex',
          flexDirection: 'row',
          listStyle: 'none',
          padding: '0px',
          width: '100%',
          justifyContent: 'space-between',
          
          margin: '0 !important'
        }}>
          <li>Admission Cell</li>
          <li>Cashier</li>
        </ul>
      </li>
      <br />
      <li>
        <ul style={{
          display: 'flex',
          flexDirection: 'row',
          listStyle: 'none',
          padding: '0px',
          width: '100%',
          justifyContent: 'space-between',
         
          margin: '0 !important'
        }}>
          <li>Student Name</li>
          <li>{data.applicant_name || 'N/A'}</li>
        </ul>
      </li>
      <li>
        <ul style={{
          display: 'flex',
          flexDirection: 'row',
          listStyle: 'none',
          padding: '0px',
          width: '100%',
          justifyContent: 'space-between',
       
          margin: '0 !important'
        }}>
          <li>Father Name</li>
          <li>{data.father_name || 'N/A'}</li>
        </ul>
      </li>
      <li>
        <ul style={{
          display: 'flex',
          flexDirection: 'row',
          listStyle: 'none',
          padding: '0px',
          width: '100%',
          justifyContent: 'space-between',
        
          margin: '0 !important'
        }}>
          <li>Category</li>
          <li>{data.category || 'N/A'}</li>
        </ul>
      </li>
      <li>
        <ul style={{
          display: 'flex',
          flexDirection: 'row',
          listStyle: 'none',
          padding: '0px',
          width: '100%',
          justifyContent: 'space-between',
          
          margin: '0 !important'
        }}>
          <li>Class</li>
          <li><span style={{ textTransform: 'uppercase',fontSize:'12px' }}>{data.course}</span> First Year</li>
        </ul>
      </li>
      <li>
        <ul style={{
          display: 'flex',
          flexDirection: 'row',
          listStyle: 'none',
          padding: '0px',
          width: '100%',
          justifyContent: 'space-between',
           
          margin: '0 !important'
        }}>
          <li>Subjects<br /> M1:{data.compulsory_subjects.split(',')[0] || 'N/A'} , M2:{data.compulsory_subjects.split(',')[1] || 'N/A'} , Minor:{data.compulsory_subjects.split(',')[2] || 'N/A'}</li>
        </ul>
      </li>
      <li>
        <ul style={{
          display: 'flex',
          flexDirection: 'row',
          listStyle: 'none',
          padding: '0px',
          width: '100%',
          justifyContent: 'space-between',
        
          margin: '0 !important'
        }}>
          <li>______</li>
          <li>______</li>
        </ul>
      </li>
      <li>
        <ul style={{
          display: 'flex',
          flexDirection: 'row',
          listStyle: 'none',
          padding: '0px',
          width: '100%',
          justifyContent: 'space-between',
         
          margin: '0 !important'
        }}>
          <li>Date</li>
          <li>Signature</li>
        </ul>
      </li>
    </ul>
  </div>
);

export default BankReceipt;